const MOBILE_AUTHORS_DISPLAYED = 1;
const DESKTOP_AUTHORS_DISPLAYED = 2;

/**
 * Returns the displayed and expandable authors based on the provided list of authors and device type.
 * @param {Array} authors - The list of authors.
 * @param {boolean} isMobile
 * @param {object} paidAuthor - The paid author object.
 */
export function getDisplayedAndExpandableAuthors(authors, isMobile, paidAuthor) {
  if (!authors?.length) {
    return { displayedAuthors: [], expandableAuthors: [] };
  }

  const sliceLimit = isMobile ? MOBILE_AUTHORS_DISPLAYED : DESKTOP_AUTHORS_DISPLAYED;

  /**
   * Splits the list of authors into displayed and expandable authors based on the slice limit.
   * @param {Array} authorList - The list of authors to be sliced.
   * @returns {object} An object containing displayedAuthors and expandableAuthors arrays.
   */
  const getSlicedAuthors = (authorList) => ({
    displayedAuthors: authorList.slice(0, sliceLimit),
    expandableAuthors: authorList.slice(sliceLimit),
  });

  if (paidAuthor) {
    const prioritizedAuthors = [paidAuthor, ...authors.filter((a) => a !== paidAuthor)];
    return getSlicedAuthors(prioritizedAuthors);
  }

  return getSlicedAuthors(authors);
}
